import React from 'react';
import './FloatingShapes.css';

const FloatingShapes = () => {
  return (
    <div className="floating-shapes">
      <div className="shape shape1"></div>
      <div className="shape shape2"></div>
    </div>
  );
};

export default FloatingShapes;
